<div class="lvi-content">
    <div class="avatar" [nSelector]="{liste: liste, item: data}">
        <i class="nio icon-avance_2"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a [routerLink]="">
                {{ data.idAvance || ('avance.liste.numeroNonDefini' | translate) }} - {{ data.libelleObjet || ('avance.liste.objetNonDefini' | translate) }}
            </a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.idOd"><strong [translate]="'ndf.avancesImputables.om'"></strong>{{ data.idOd }}</li>
            <li><strong [translate]="'ndf.avancesImputables.type'"></strong>{{ NatureAvance.traduction(data.nature) | translate }}</li>
            <li><strong [translate]="'ndf.avancesImputables.montantDisponible'"></strong>{{ data.montant | montant:data.devise }}</li>
            <li *ngIf="extraOptions.avSettings?.isChangeAvance" [class.back-danger-invert]="isMontantImputeInvalid()">
                <strong [translate]="'ndf.avancesImputables.montantImpute'"></strong>
                <!-- Affichage du montant (mode lecture) -->
                <span *ngIf="!isEditActive">{{ montantImpute | montant:data.devise }}</span>
                <!-- Input d'édition du montant (mode édition) avec devise -->
                <span *ngIf="isEditActive">
                    <input #montantEditInput
                           type="text"
                           class="montant-edit-input"
                           [(ngModel)]="montantImpute"
                           (keydown)="onKeyDown($event)"
                           (keydown.enter)="onValidateMontant()"
                           (keydown.escape)="onCancelEdit()"
                           (blur)="onCancelEdit()"
                           (input)="onInput($event); adjustWidth()"/>&#160;{{ data.devise }}
                </span>
                <!-- Span invisible pour calculer la largeur de l'input -->
                <span #montantEditInputWidthCalculator class="invisible">{{ montantImpute }}</span>
                <!-- Icône info avec tooltip (montant invalide) -->
                <mat-icon *ngIf="isMontantImputeInvalid()" class="edit-icon" [matTooltip]="'ndf.avancesImputables.erreurMontantSuperieur' | translate">info</mat-icon>
                <!-- Icône edit/check -->
                <mat-icon *ngIf="isEditActive" class="edit-icon" color="primary" (mousedown)="$event.preventDefault()" (click)="onValidateMontant()">save</mat-icon>
                <mat-icon *ngIf="!isEditActive" class="edit-icon" color="primary" (click)="modifierMontant()">edit</mat-icon>
            </li>
            <li *ngIf="!extraOptions.avSettings?.isChangeAvance"><strong [translate]="'ndf.avancesImputables.montantImpute'"></strong>{{ montantImpute | montant:data.devise }}</li>
            <li *ngIf="data.devise !== extraOptions.deviseEntreprise"><strong [translate]="'ndf.avancesImputables.taux'"></strong>{{ data.taux | number:'1.3-3' }}</li>
        </ul>
    </div>
</div>
